/**
 * ENUM for Packs
 **/
export enum Products {
  PEB = 1,
  PEB_Partiel = 11,
  ELEC = 4,
  ELEC_SUPP = 8,
  CITERNE_ENTERREE = 9,
  CITERNE_AERIENNE = 6,
  PLAN = 14,
  GAZ_CONTROLE = 15,
  GAZ_SUPP = 16,
  ISO = 17,
  DESCRIPTIF = 27,
  PLAN3D = 26,
  VISITE360 = 21,
  PHOTO = 18,
  PHOTODRONE = 19,
  PEBCHAUFFAGE = 28,
  PEB_ELEC = 51,
  MEDIA = 52,
  IMMO_LIGHT = 53,
  IMMO = 54,
  GAZ_ELEC = 55
}
